import { useEffect, useState } from "react";
import axios from "axios";
import ProjectCard from "@/components/ProjectCard";
import "@/styles/ProjectsPage.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API}/projects`);
        setProjects(response.data);
      } catch (error) {
        console.error("Error cargando proyectos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const filteredProjects = filter === "all" 
    ? projects 
    : projects.filter(p => p.category.toLowerCase() === filter.toLowerCase());

  return (
    <div className="projects-page" data-testid="projects-page">
      <div className="projects-hero">
        <div className="container">
          <h1 className="projects-title fade-in-up" data-testid="projects-title">Nuestros Proyectos</h1>
          <p className="projects-subtitle fade-in-up" data-testid="projects-subtitle">
            Descubre nuestra experiencia en construcción residencial, comercial e institucional
          </p>
        </div>
      </div>

      <div className="container section-padding">
        <div className="filter-buttons" data-testid="filter-buttons">
          <button 
            className={filter === "all" ? "active" : ""}
            onClick={() => setFilter("all")}
            data-testid="filter-all-btn"
          >
            Todos
          </button>
          <button 
            className={filter === "residencial" ? "active" : ""}
            onClick={() => setFilter("residencial")}
            data-testid="filter-residencial-btn"
          >
            Residencial
          </button>
          <button 
            className={filter === "comercial" ? "active" : ""}
            onClick={() => setFilter("comercial")}
            data-testid="filter-comercial-btn"
          >
            Comercial
          </button>
          <button 
            className={filter === "institucional" ? "active" : ""}
            onClick={() => setFilter("institucional")}
            data-testid="filter-institucional-btn"
          >
            Institucional
          </button>
        </div>

        {loading ? (
          <div className="loading-state" data-testid="projects-loading">
            <div className="spinner"></div>
            <p>Cargando proyectos...</p>
          </div>
        ) : filteredProjects.length === 0 ? (
          <div className="empty-state" data-testid="projects-empty">
            <p>Próximamente agregaremos proyectos en esta categoría</p>
          </div>
        ) : (
          <div className="projects-grid" data-testid="projects-grid">
            {filteredProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsPage;